import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/customMappings'
import Component from 'components/CustomMappings'

export default createListViewContainer({ actions, selectors: selectors.customMappings })(Component)
